import React from 'react';
import { ventures } from '../data/ventures';
import { Wordmark } from './Wordmark';
export function Ventures() {
  return <section id="ventures" className="border-b border-rule bg-paper-alt" data-id="element-87" data-mp="bvdezh4fsk66">
      <div className="mx-auto max-w-page px-6 py-20 lg:px-10 lg:py-28" data-id="element-88" data-mp="7u1o789ttswe">
        <div className="grid gap-8 lg:grid-cols-12" data-id="element-89" data-mp="2vgl9136wv49">
          <div className="lg:col-span-4" data-id="element-90" data-mp="2wrwtn2vn75x">
            <p className="font-sans text-[12px] uppercase tracking-overline text-muted" data-id="element-91" data-mp="zlpupe5xbl7b">
              The portfolio
            </p>
            <h2 className="mt-6 font-serif text-[clamp(2rem,4vw,3.25rem)] leading-[1.02] tracking-[-0.02em] text-ink" data-id="element-92" data-mp="vjvxxgyun1cf">
              Things I started
            </h2>
          </div>
          <p className="font-sans text-[15px] leading-[1.7] text-ink-soft lg:col-span-5 lg:col-start-6" data-id="element-93" data-mp="luktw8qtkmve">
            Some are still running, most have run their course — which is the honest shape of a
            builder’s career. Each one taught me something I now use on the advisory side of the
            desk.
          </p>
        </div>

        <ol className="mt-16 border-t border-rule" data-id="element-94" data-mp="c3nu1hymun54">
          {ventures.map((venture, index) => <li key={venture.id} className="group border-b border-rule" data-id="element-95" data-mp="h1pg8brcv2kt" data-mpi={index}>
              <article className="grid grid-cols-1 items-start gap-y-4 py-8 transition-colors duration-200 ease-out group-hover:bg-paper lg:grid-cols-12 lg:gap-x-8 lg:px-4" data-id="element-96" data-mp="39rbse8l9uuz">
                <div className="flex items-baseline gap-4 lg:col-span-4" data-id="element-97" data-mp="3piadwweje98m">
                  <span aria-hidden="true" className="font-sans text-[12px] tabular-nums text-muted" data-id="element-98" data-mp="3pkdfmdp1xqt6">
                    {String(ventures.length - index).padStart(2, '0')}
                  </span>
                  <div data-id="element-99" data-mp="3gjozndg3lgdn">
                    <h3 className="text-ink" data-id="element-100" data-mp="3kio4yz5qrf5m">
                      <Wordmark name={venture.name} mark={venture.mark} data-id="element-101" data-mp="3kjfw9xsb2qq3" />
                    </h3>
                    <p className="mt-2 font-sans text-[12px] uppercase tracking-[0.14em] text-muted" data-id="element-102" data-mp="1eqh9f8yy5ecz">
                      {venture.category} · {venture.place}
                    </p>
                  </div>
                </div>

                <div className="lg:col-span-5" data-id="element-103" data-mp="2rm54kjci1xma">
                  <p className="font-sans text-[16px] leading-[1.6] text-ink" data-id="element-104" data-mp="2mod95fcnbtdc">{venture.thesis}</p>
                  {venture.brands ? <ul className="mt-4 flex flex-wrap gap-x-2 gap-y-2" data-id="element-105" data-mp="2ipxhuz9j7yu4">
                      {venture.brands.map(brand => <li key={brand} className="border border-rule bg-paper px-2 py-[3px] font-sans text-[12px] text-ink-soft" data-id="element-106" data-mp="3aer5vj66ege9">
                          {brand}
                        </li>)}
                    </ul> : null}
                </div>

                <div className="lg:col-span-3 lg:text-right" data-id="element-107" data-mp="2wlhz7q9m48zf">
                  <p className="font-sans text-[14px] font-medium text-ink" data-id="element-108" data-mp="3u41i2n6pqj7m">{venture.role}</p>
                  <p className="mt-1 font-sans text-[13px] tabular-nums text-muted" data-id="element-109" data-mp="3pb8fa4ut1ky6">
                    {venture.years}
                  </p>
                  <p className="mt-3" data-id="element-110" data-mp="k4nzqatewls">
                    <span className={`inline-block border px-2 py-[3px] font-sans text-[11px] uppercase tracking-[0.12em] ${venture.status === 'Operating' ? 'border-accent/40 text-accent' : 'border-rule text-muted'}`} data-id="element-111" data-mp="5glh6ywvg15q">
                      {venture.status}
                    </span>
                  </p>
                </div>
              </article>
            </li>)}
        </ol>
      </div>
    </section>;
}